(function () {
  'use strict';
  if (window.__saiPdpGuardInstalled) return;
  window.__saiPdpGuardInstalled = true;

  function getContext(node) {
    var root = node && node.closest ? node.closest('[data-sai-product]') : null;
    if (!root) root = document.querySelector('[data-sai-product]');
    if (!root) {
      return null;
    }
    var configNode = document.querySelector('[data-sai-pdp-config]');
    if (!configNode) {
      return null;
    }
    try {
      var config = JSON.parse(configNode.textContent);
      if (!config.variants || !config.variants.length) {
        return null;
      }
      return { root: root, variants: config.variants, moneyFormat: config.moneyFormat };
    } catch (error) {
      return null;
    }
  }

  function formatMoney(cents, format) {
    try {
      if (window.Shopify && Shopify.formatMoney) return Shopify.formatMoney(cents, format);
    } catch (error) {}
    return '$' + (Number(cents || 0) / 100).toFixed(2);
  }

  function desiredVariant(context) {
    var blocks = Array.prototype.slice.call(context.root.querySelectorAll('[data-option-position]'));
    if (!blocks.length) return context.variants[0] || null;
    blocks.sort(function (a, b) {
      return Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition);
    });
    var selected = blocks.map(function (block) {
      var active = block.querySelector('.sai-var-tab-on[data-sai-option-value]');
      return active ? String(active.dataset.saiOptionValue) : null;
    });
    if (selected.some(function (value) { return value === null; })) return null;
    return context.variants.find(function (variant) {
      return variant.options.length === selected.length && variant.options.every(function (option, index) {
        return String(option) === selected[index];
      });
    }) || null;
  }

  function reconcile(context) {
    if (!context) return false;
    var variant = desiredVariant(context);
    var hidden = context.root.querySelector('[data-sai-variant-id]');
    var add = context.root.querySelector('[data-sai-add]');
    var price = context.root.querySelector('[data-sai-price]');
    var compare = context.root.querySelector('[data-sai-compare]');
    var stickyAdd = document.querySelector('[data-sai-sticky-add]');
    var stickyPrice = document.querySelector('[data-sai-sticky-price]');
    if (!variant) {
      if (hidden) hidden.value = '';
      if (add) {
        add.disabled = true;
        add.classList.add('sold');
        add.textContent = 'Unavailable — choose another option';
      }
      if (stickyAdd) {
        stickyAdd.disabled = true;
        stickyAdd.textContent = 'Unavailable';
      }
      return false;
    }
    var formatted = formatMoney(variant.price, context.moneyFormat);
    if (hidden) hidden.value = String(variant.id);
    if (price) price.textContent = formatted;
    if (stickyPrice) stickyPrice.textContent = formatted;
    if (compare) {
      var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
      compare.hidden = !onSale;
      compare.textContent = onSale ? formatMoney(variant.compare_at_price, context.moneyFormat) : '';
    }
    if (add) {
      add.disabled = !variant.available;
      add.classList.toggle('sold', !variant.available);
      add.textContent = variant.available ? 'Add to cart — ' + formatted : 'Sold out';
    }
    if (stickyAdd) {
      stickyAdd.disabled = !variant.available;
      stickyAdd.textContent = variant.available ? 'Add to cart' : 'Sold out';
    }
    return !!variant.available;
  }

  function purchaseIsSafe(context) {
    if (!context) return false;
    var variant = desiredVariant(context);
    var hidden = context.root.querySelector('[data-sai-variant-id]');
    return !!(variant && variant.available && hidden && String(hidden.value) === String(variant.id));
  }

  document.addEventListener('click', function (event) {
    var option = event.target && event.target.closest && event.target.closest('[data-sai-option-value]');
    if (option) {
      var context = getContext(option);
      if (!context) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      var block = option.closest('[data-option-position]');
      if (!block) return;
      block.querySelectorAll('[data-sai-option-value]').forEach(function (button) {
        button.classList.remove('sai-var-tab-on');
      });
      option.classList.add('sai-var-tab-on');
      var label = block.querySelector('[data-sai-option-label]');
      if (label) label.textContent = option.dataset.saiOptionValue;
      reconcile(context);
      return;
    }
    var sticky = event.target && event.target.closest && event.target.closest('[data-sai-sticky-add]');
    if (sticky) {
      var stickyContext = getContext(document.querySelector('[data-sai-product]'));
      if (!purchaseIsSafe(stickyContext)) {
        event.preventDefault();
        event.stopImmediatePropagation();
        reconcile(stickyContext);
        return;
      }
      var add = stickyContext.root.querySelector('[data-sai-add]');
      if (add && !add.disabled) {
        event.preventDefault();
        event.stopImmediatePropagation();
        add.click();
      }
      return;
    }
    var payment = event.target && event.target.closest && event.target.closest('.shopify-payment-button');
    if (payment) {
      var paymentContext = getContext(payment);
      if (!purchaseIsSafe(paymentContext)) {
        event.preventDefault();
        event.stopImmediatePropagation();
        reconcile(paymentContext);
      }
    }
  }, true);

  document.addEventListener('submit', function (event) {
    var form = event.target && event.target.closest && event.target.closest('.sai-product-form');
    if (!form) return;
    var context = getContext(form);
    event.preventDefault();
    event.stopImmediatePropagation();
    if (!reconcile(context) || !purchaseIsSafe(context) || form.dataset.saiSubmitting === 'true') return;
    form.dataset.saiSubmitting = 'true';
    var add = context.root.querySelector('[data-sai-add]');
    var priorText = add ? add.textContent : '';
    if (add) {
      add.disabled = true;
      add.textContent = 'Adding…';
    }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: new FormData(form)
    }).then(function (response) {
      if (!response.ok) throw new Error('Cart add failed');
      return response.json();
    }).then(function () {
      window.location.assign('/cart');
    }).catch(function () {
      form.dataset.saiSubmitting = 'false';
      if (add) {
        add.disabled = false;
        add.textContent = priorText;
      }
      var message = context.root.querySelector('[data-sai-cart-error]');
      if (!message) {
        message = document.createElement('p');
        message.setAttribute('data-sai-cart-error', '');
        message.setAttribute('role', 'alert');
        add.parentNode.insertAdjacentElement('afterend', message);
      }
      message.textContent = 'We could not add this item. Please try again.';
    });
  }, true);

  function initialize() {
    var context = getContext(document.querySelector('[data-sai-product]'));
    reconcile(context);
  }
  var refreshTimer;
  var observerInstalled = false;
  function installObserver() {
    if (observerInstalled) return;
    var productHost = document.querySelector('#content') || document.body;
    if (!productHost) return;
    observerInstalled = true;
    new MutationObserver(function (mutations) {
      var productSectionReplaced = mutations.some(function (mutation) {
        return Array.prototype.some.call(mutation.addedNodes, function (node) {
          return node.nodeType === 1 && (
            node.matches('[data-sai-product], [data-sai-variant-id]') ||
            node.querySelector('[data-sai-product], [data-sai-variant-id]')
          );
        });
      });
      if (!productSectionReplaced) return;
      clearTimeout(refreshTimer);
      refreshTimer = setTimeout(initialize, 0);
    }).observe(productHost, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initialize();
      installObserver();
    }, { once: true });
  } else {
    initialize();
    installObserver();
  }
  document.addEventListener('shopify:section:load', initialize);
})();
